"use strict";

(function () {
  var MIN_QUERY_LENGTH = 1;
  var DEBOUNCE_MS = 180;
  var PLACEHOLDER_INTERVAL_MS = 2600;

  function icon(kind) {
    var wrapper = document.createElement("span");
    wrapper.className =
      kind === "collection"
        ? "predictive-search__collection-icon"
        : "predictive-search__query-icon";
    wrapper.setAttribute("aria-hidden", "true");

    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 24 24");
    var first = document.createElementNS("http://www.w3.org/2000/svg", kind === "collection" ? "path" : "circle");
    if (kind === "collection") {
      first.setAttribute("d", "M4 6.5h16v12H4zM8 6.5V4h8v2.5");
    } else {
      first.setAttribute("cx", "10.5");
      first.setAttribute("cy", "10.5");
      first.setAttribute("r", "6.5");
    }
    svg.appendChild(first);
    if (kind !== "collection") {
      var handle = document.createElementNS("http://www.w3.org/2000/svg", "path");
      handle.setAttribute("d", "m16 16 4 4");
      svg.appendChild(handle);
    }
    wrapper.appendChild(svg);
    return wrapper;
  }

  function optionLink(url, className, id) {
    var link = document.createElement("a");
    link.href = url;
    link.className = "predictive-search__option " + className;
    link.id = id;
    link.setAttribute("role", "option");
    link.setAttribute("aria-selected", "false");
    return link;
  }

  function group(label) {
    var section = document.createElement("div");
    section.className = "predictive-search__group";
    var heading = document.createElement("div");
    heading.className = "predictive-search__heading";
    heading.textContent = label;
    section.appendChild(heading);
    return section;
  }

  function formatPrice(value, locale) {
    var price = Number(value);
    if (!Number.isFinite(price)) return "";
    return price.toFixed(2) + (locale === "ar" ? " د.أ" : " JD");
  }

  function normalizeFallbackProduct(product) {
    var image = "";
    if (product.images && product.images.length) {
      image = product.images[0].src || product.images[0];
    }
    var price = product.variants && product.variants.length ? product.variants[0].price : "";
    return {
      title: product.title,
      vendor: product.vendor,
      url: "/products/" + product.handle,
      image: image,
      price: price,
      featured_image: image ? { url: image, alt: product.title } : null,
    };
  }

  function init(form, formIndex) {
    var input = form.querySelector(".header__search-input");
    var results = form.querySelector("[data-predictive-results]");
    var content = form.querySelector("[data-predictive-content]");
    var status = form.querySelector("[data-predictive-status]");
    var placeholderSuffix = form.querySelector("[data-search-placeholder-suffix]");
    if (!input || !results || !content || !status) return;

    var debounceTimer = 0;
    var placeholderTimer = 0;
    var placeholderIndex = 0;
    var requestController = null;
    var activeIndex = -1;
    var locale = form.getAttribute("data-locale") || "en";
    var root = form.getAttribute("data-search-root") || "/";
    var placeholderPrefix = form.getAttribute("data-placeholder-prefix") || "Search";
    var placeholderItems = (form.getAttribute("data-placeholder-items") || "")
      .split(/\r?\n|,/)
      .map(function (item) { return item.trim(); })
      .filter(Boolean);

    function setPlaceholder(index) {
      if (!placeholderItems.length || !placeholderSuffix || input.value || document.activeElement === input) return;
      placeholderSuffix.classList.add("is-changing");
      window.setTimeout(function () {
        var item = placeholderItems[index % placeholderItems.length];
        placeholderSuffix.textContent = item;
        placeholderSuffix.classList.remove("is-changing");
      }, 160);
    }

    function startPlaceholderRotation() {
      if (
        placeholderItems.length < 2 ||
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ) return;
      window.clearInterval(placeholderTimer);
      placeholderTimer = window.setInterval(function () {
        placeholderIndex = (placeholderIndex + 1) % placeholderItems.length;
        setPlaceholder(placeholderIndex);
      }, PLACEHOLDER_INTERVAL_MS);
    }

    function stopPlaceholderRotation() {
      window.clearInterval(placeholderTimer);
    }

    function setOpen(open) {
      results.hidden = !open;
      input.setAttribute("aria-expanded", open ? "true" : "false");
      document.documentElement.classList.toggle("predictive-search-open", open);
      if (open && window.matchMedia("(max-width: 991.98px)").matches) {
        var rect = form.getBoundingClientRect();
        results.style.setProperty("--predictive-search-top", Math.round(rect.bottom + 8) + "px");
      }
      if (!open) {
        activeIndex = -1;
        input.removeAttribute("aria-activedescendant");
      }
    }

    function setLoading() {
      content.replaceChildren();
      var loading = document.createElement("div");
      loading.className = "predictive-search__loading";
      loading.textContent = form.getAttribute("data-label-loading") || "Finding products…";
      content.appendChild(loading);
      status.textContent = loading.textContent;
      setOpen(true);
    }

    function updateActive(nextIndex) {
      var options = Array.prototype.slice.call(content.querySelectorAll('[role="option"]'));
      if (!options.length) return;
      activeIndex = (nextIndex + options.length) % options.length;
      options.forEach(function (option, index) {
        var active = index === activeIndex;
        option.classList.toggle("is-active", active);
        option.setAttribute("aria-selected", active ? "true" : "false");
      });
      input.setAttribute("aria-activedescendant", options[activeIndex].id);
      options[activeIndex].scrollIntoView({ block: "nearest" });
    }

    function appendQueries(fragment, queries, optionSeed) {
      if (!queries.length) return optionSeed;
      var queriesGroup = group(form.getAttribute("data-label-suggestions") || "Suggestions");
      queries.slice(0, 4).forEach(function (query) {
        var link = optionLink(query.url, "predictive-search__query", "PredictiveOption-" + formIndex + "-" + optionSeed++);
        link.appendChild(icon("query"));
        var label = document.createElement("span");
        label.textContent = query.text;
        link.appendChild(label);
        queriesGroup.appendChild(link);
      });
      fragment.appendChild(queriesGroup);
      return optionSeed;
    }

    function appendCollections(fragment, collections, optionSeed) {
      if (!collections.length) return optionSeed;
      var collectionsGroup = group(form.getAttribute("data-label-collections") || "Collections");
      collections.slice(0, 3).forEach(function (collection) {
        var link = optionLink(collection.url, "predictive-search__collection", "PredictiveOption-" + formIndex + "-" + optionSeed++);
        link.appendChild(icon("collection"));
        var label = document.createElement("span");
        label.textContent = collection.title;
        link.appendChild(label);
        collectionsGroup.appendChild(link);
      });
      fragment.appendChild(collectionsGroup);
      return optionSeed;
    }

    function appendProducts(fragment, products, optionSeed, popular) {
      if (!products.length) return optionSeed;
      var productsGroup = group(
        popular
          ? form.getAttribute("data-label-popular") || "Popular picks"
          : form.getAttribute("data-label-products") || "Products"
      );
      products.slice(0, 6).forEach(function (product) {
        var link = optionLink(product.url, "predictive-search__product", "PredictiveOption-" + formIndex + "-" + optionSeed++);
        var featuredImage = product.featured_image;
        var imageUrl = featuredImage && (featuredImage.url || featuredImage.src);
        if (imageUrl) {
          var image = document.createElement("img");
          image.className = "predictive-search__product-image";
          image.src = imageUrl;
          image.alt = featuredImage.alt || product.title || "";
          image.width = 54;
          image.height = 54;
          image.loading = "lazy";
          link.appendChild(image);
        }
        var copy = document.createElement("span");
        copy.className = "predictive-search__product-copy";
        var title = document.createElement("span");
        title.className = "predictive-search__product-title";
        title.textContent = product.title;
        copy.appendChild(title);
        var meta = document.createElement("span");
        meta.className = "predictive-search__product-meta";
        var pieces = [product.vendor, formatPrice(product.price, locale)].filter(Boolean);
        meta.textContent = pieces.join(" · ");
        copy.appendChild(meta);
        link.appendChild(copy);
        productsGroup.appendChild(link);
      });
      fragment.appendChild(productsGroup);
      return optionSeed;
    }

    function render(data, query, popular) {
      var products = data.products || [];
      var collections = data.collections || [];
      var queries = data.queries || [];
      var fragment = document.createDocumentFragment();
      var optionSeed = 0;

      optionSeed = appendQueries(fragment, queries, optionSeed);
      optionSeed = appendCollections(fragment, collections, optionSeed);
      optionSeed = appendProducts(fragment, products, optionSeed, popular);

      var viewAllUrl = new URL(root + "search", window.location.origin);
      viewAllUrl.searchParams.set("q", query);
      viewAllUrl.searchParams.set("type", "product");
      var viewAll = optionLink(viewAllUrl.toString(), "predictive-search__view-all", "PredictiveOption-" + formIndex + "-" + optionSeed++);
      var viewAllText = document.createElement("span");
      viewAllText.textContent = (form.getAttribute("data-label-view-all") || "See all results for") + " “" + query + "”";
      var arrow = document.createElement("span");
      arrow.setAttribute("aria-hidden", "true");
      arrow.textContent = "→";
      viewAll.appendChild(viewAllText);
      viewAll.appendChild(arrow);
      fragment.appendChild(viewAll);

      content.replaceChildren(fragment);
      activeIndex = -1;
      var optionCount = content.querySelectorAll('[role="option"]').length;
      status.textContent = optionCount + " " + (form.getAttribute("data-label-count") || "suggestions available");
      setOpen(optionCount > 0);
    }

    async function predictiveRequest(query, signal) {
      var url = new URL(root + "search/suggest.json", window.location.origin);
      url.searchParams.set("q", query);
      url.searchParams.set("resources[type]", "product,collection,query");
      url.searchParams.set("resources[limit]", "6");
      url.searchParams.set("resources[options][unavailable_products]", "hide");
      url.searchParams.set("resources[options][fields]", "title,product_type,vendor,variants.title,tag");
      var response = await fetch(url.toString(), { signal: signal, headers: { Accept: "application/json" } });
      if (!response.ok) throw new Error("Predictive search unavailable");
      var payload = await response.json();
      return payload.resources && payload.resources.results
        ? payload.resources.results
        : { products: [], collections: [], queries: [] };
    }

    async function popularRequest(signal) {
      var handle = form.getAttribute("data-fallback-collection") || "best-sellers";
      var url = new URL(root + "collections/" + encodeURIComponent(handle) + "/products.json", window.location.origin);
      url.searchParams.set("limit", "6");
      var response = await fetch(url.toString(), { signal: signal, headers: { Accept: "application/json" } });
      if (!response.ok) throw new Error("Fallback products unavailable");
      var payload = await response.json();
      return (payload.products || []).filter(function (product) {
        return product.variants && product.variants.some(function (variant) { return variant.available; });
      }).map(normalizeFallbackProduct);
    }

    async function searchFor(query) {
      if (requestController) requestController.abort();
      requestController = new AbortController();
      setLoading();

      try {
        var data = await predictiveRequest(query, requestController.signal);
        var hasMatches = data.products.length || data.collections.length || data.queries.length;

        if (!hasMatches) {
          var tokens = query.split(/\s+/).filter(function (token) { return token.length >= 3; });
          for (var index = 0; index < tokens.length; index++) {
            if (tokens[index].toLowerCase() === query.toLowerCase()) continue;
            data = await predictiveRequest(tokens[index], requestController.signal);
            if (data.products.length || data.collections.length || data.queries.length) {
              hasMatches = true;
              break;
            }
          }
        }

        if (!hasMatches) {
          var popularProducts = await popularRequest(requestController.signal);
          render({ products: popularProducts, collections: [], queries: [] }, query, true);
        } else {
          render(data, query, false);
        }
      } catch (error) {
        if (error.name !== "AbortError") setOpen(false);
      }
    }

    input.addEventListener("input", function () {
      stopPlaceholderRotation();
      window.clearTimeout(debounceTimer);
      var query = input.value.trim();
      form.classList.toggle("has-search-value", query.length > 0);
      if (query.length < MIN_QUERY_LENGTH) {
        if (requestController) requestController.abort();
        setOpen(false);
        return;
      }
      debounceTimer = window.setTimeout(function () { searchFor(query); }, DEBOUNCE_MS);
    });

    input.addEventListener("focus", function () {
      stopPlaceholderRotation();
      if (input.value.trim().length >= MIN_QUERY_LENGTH) searchFor(input.value.trim());
    });

    input.addEventListener("blur", function () {
      if (!input.value) startPlaceholderRotation();
    });

    input.addEventListener("keydown", function (event) {
      if (results.hidden) return;
      var options = content.querySelectorAll('[role="option"]');
      if (event.key === "ArrowDown") {
        event.preventDefault();
        updateActive(activeIndex + 1);
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        updateActive(activeIndex - 1);
      } else if (event.key === "Enter" && activeIndex >= 0 && options[activeIndex]) {
        event.preventDefault();
        options[activeIndex].click();
      } else if (event.key === "Escape") {
        event.preventDefault();
        setOpen(false);
      }
    });

    form.addEventListener("submit", function () { setOpen(false); });
    document.addEventListener("pointerdown", function (event) {
      if (!form.contains(event.target)) setOpen(false);
    });
    window.addEventListener("resize", function () {
      if (!results.hidden && window.matchMedia("(max-width: 991.98px)").matches) {
        var rect = form.getBoundingClientRect();
        results.style.setProperty("--predictive-search-top", Math.round(rect.bottom + 8) + "px");
      }
    });

    if (placeholderItems.length) {
      setPlaceholder(0);
      startPlaceholderRotation();
    }
  }

  document.querySelectorAll("[data-predictive-search]").forEach(init);
})();
